import Vue from 'vue'
import Router from 'vue-router'



Vue.use(Router)

const tpl = {
  template: '<router-view></router-view>'
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/correctHomeworkWrong'
    },
    {
      path: '/eraserImage',
      name: 'eraserImage',
      component: r => require.ensure([], () => r(require('@/views/eraserImage')), 'eraserImage'),
      meta: {
        title: '橡皮擦' // 
      }
    },
    {
      path: '/manualCropperImg',
      name: 'manualCropperImg',
      component: r => require.ensure([], () => r(require('@/views/manualCropperImg')), 'manualCropperImg'),
      meta: {
        title: '裁切编辑' // 
      }
    },
    {
      path: '/addSource',
      name: 'addSource',
      component: r => require.ensure([], () => r(require('@/views/addSource')), 'addSource'),
      meta: {
        title: '增加来源' // 
      }
    },
    {
      path: '/singleQuestionCropperImg',
      name: 'singleQuestionCropperImg',
      component: r => require.ensure([], () => r(require('@/views/singleQuestionCropperImg')), 'singleQuestionCropperImg'),
      meta: {
        title: '调整切题区域' // 
      }
    },
    {
      path: '/manualWrongQuestionCropper',
      name: 'manualWrongQuestionCropper',
      component: r => require.ensure([], () => r(require('@/views/manualWrongQuestionCropper')), 'manualWrongQuestionCropper'),
      meta: {
        title: '手动框错题' // 
      }
    },
    {
      path: '/signature',
      name: 'signature',
      component: r => require.ensure([], () => r(require('@/views/signature')), 'signature'),
      meta: {
        title: '签名' // 
      }
    },
    {
      path: '/chatAI',
      name: 'chatAI',
      component: r => require.ensure([], () => r(require('@/views/chatAI')), 'chatAI'),
      meta: {
        title: 'AI场景对话' // 
      }
    },
    {
      path: '/questionAiDialogue',
      name: 'questionAiDialogue',
      component: r => require.ensure([], () => r(require('@/views/questionAiDialogue')), 'questionAiDialogue'),
      meta: {
        title: '题目解析' 
      }
    },
    {
      path: '/yooTeacherAI',
      name: 'yooTeacherAI',
      component: r => require.ensure([], () => r(require('@/views/yooTeacherAI')), 'yooTeacherAI'),
      meta: {
        title: '小悠老师' 
      }
    },
    {
      path: '/questionsTemplateExport',
      name: 'questionsTemplateExport',
      component: r => require.ensure([], () => r(require('@/views/questionsTemplateExport')), 'questionsTemplateExport'),
      meta: {
        title: '题目模版' 
      }
    },
    {
      path: '/questionListSort',
      name: 'questionListSort',
      component: r => require.ensure([], () => r(require('@/views/questionListSort')), 'questionListSort'),
      meta: {
        title: '题目排序' 
      }
    },
    {
      path: '/imgsAnnotation',
      name: 'imgsAnnotation',
      component: r => require.ensure([], () => r(require('@/views/questionImgsAnnotation/index.vue')), 'questionImgsAnnotation'),
      meta: {
        title: '图片标注' 
      }
    },
    {
      path: '/correctHomeworkWrong',
      name: 'correctHomeworkWrong',
      component: r => require.ensure([], () => r(require('@/views/correctHomeworkWrong')), 'correctHomeworkWrong'),
      meta: {
        title: '错题订正' // 在线作业订正
      }
    },
    {
      path: '/learningSituationTest',
      name: 'learningSituationTest',
      component: r => require.ensure([], () => r(require('@/views/learningSituationTest')), 'learningSituationTest'),
      meta: {
        title: '学情报告'
      }
    },
    {
      path: '/onlineQuiz',
      name: 'onlineQuiz',
      component: r => require.ensure([], () => r(require('@/views/onlineQuiz')), 'onlineQuiz'),
      meta: {
        title: '在线答题'
      }
    },
    {
      path: '/mistakeDetails',
      name: 'mistakeDetails',
      component: r => require.ensure([], () => r(require('@/views/mistakeDetails')), 'mistakeDetails'),
      meta: {
        title: '题目分析'
      }
    },
    {
      path: '/pdfPreview',
      name: 'pdfPreview',
      component: r => require.ensure([], () => r(require('@/views/pdfPreview')), 'pdfPreview'),
      meta: {
        title: 'PDF'
      }
    },
    {
      path: '/pdfPreviewCarousel',
      name: 'pdfPreviewCarousel',
      component: r => require.ensure([], () => r(require('@/views/pdfPreviewCarousel')), 'pdfPreviewCarousel'),
      meta: {
        title: '导出错题'
      }
    },
    {
      path: '/pdfPreviewCheck',
      name: 'pdfPreviewCheck',
      component: r => require.ensure([], () => r(require('@/views/pdfPreviewCheck')), 'pdfPreviewCarousel'),
      meta: {
        title: '错题预览'
      }
    },
    {
      path: '/correctCustomHomeworkWrong',
      name: 'correctCustomHomeworkWrong',
      component: r => require.ensure([], () => r(require('@/views/correctCustomHomeworkWrong')), 'correctCustomHomeworkWrong'),
      meta: {
        title: '错题订正' // 学评订正
      }
    },
    {
      path: '/testCollection',
      name: 'testCollection',
      component: r => require.ensure([], () => r(require('@/views/testCollection')), 'testCollection'),
      meta: {
        title: '测试集'
      }
    },
    {
      path: '/testCollection',
      name: 'testCollection',
      component: r => require.ensure([], () => r(require('@/views/testCollection')), 'testCollection'),
      meta: {
        title: '测试集'
      }
    },
    {

      path: '/xkwDemo',
      name: 'xkwDemo',
      component: r => require.ensure([], () => r(require('@/views/xkwApi')), 'xkwApi'),
      meta: {
        title: '学科网接口对接' //
      }
    },
    {
      path: '/imageAnnotation',
      name: 'imageAnnotation',
      component: r => require.ensure([], () => r(require('@/views/questionImgsAnnotation')), 'questionImgsAnnotation'),
      meta: {
        title: '图片标注'

      }
    },
    {
      path: '/pdfPreviewCarousel',
      name: 'pdfPreviewCarousel',
      component: r => require.ensure([], () => r(require('@/views/pdfPreviewCarousel')), 'pdfPreviewCarousel'),
      meta: {
        title: 'PDF'
      }
    },
    {
      path: '/testDetailsTeacher',
      name: 'TestDetailsTeacher',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/testDetailsTeacher')), 'TestDetailsTeacher'),
      meta: {
        title: '学生作业'
      }
    },
    {
      path: '/testDetails',
      name: 'TestDetails',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/testDetails')), 'TestDetails'),
      meta: {
        title: '学生作业详情'
      }
    },
    {
      path: '/wongExamPaper',
      name: 'wongExamPaper',
      component: r => require.ensure([], () => r(require('@/views/wongExamPaper')), 'wongExamPaper'),
      meta: {
        title: '错题卷详情'
      }
    },
  ],
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js